<template>
  <div class="popup-main">
    <el-dialog
      width="1000px"
      title="工程协同"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div class="popup-cont">
        <e-form
          ref="refForm"
          :config="formConfig"
          :column="formColumn"
          :data.sync="selfData.formData"
        />
        <div class="group-title m-t-10">选择协同商品</div>
        <vxe-grid
          ref="refTable"
          :min-height="tableConfig.minHeight"
          :toolbar-config="tableConfig.toolbarConfig"
          :edit-config="tableConfig.editConfig"
          :row-config="tableConfig.rowConfig"
          :mouse-config="tableConfig.mouseConfig"
          :keyboard-config="tableConfig.keyboardConfig"
          :columns="tableColumn"
          :data="selfData.tableData"
          :show-footer="!!selfData.tableData.length"
          :max-height="this.$util.getViewHeight() - 440"
          :footer-method="footerMethod"
        >
          <!-- slot_default -->
          <template #default_list_chan_pin_tu="{ row }">
            <e-upload-image
              v-if="row.list_chan_pin_tu"
              :list.sync="row.list_chan_pin_tu"
              disabled
            />
          </template>
          <template #default_sales_price="{ row }">
            {{ row.sales_price || '0.00' }}
          </template>
          <template #default_sales_amount="{ row }">
            {{ row.sales_amount || '0.00' }}
          </template>

          <!-- slot_edit -->
          <template #edit_xie_tong_bei_zhu="{ row }">
            <el-input v-model="row.xie_tong_bei_zhu" type="text" size="mini" />
          </template>
        </vxe-grid>
      </div>
      <div slot="footer">
        <el-button size="mini" type="primary" @click="popupConfirm">创建</el-button>
      </div>
    </el-dialog>

    <!-- 弹窗-新增 -->
    <PopupChooseOrder
      v-if="isShowPopupChooseOrder"
      :show.sync="isShowPopupChooseOrder"
      @success="chooseOrderSuccess"
    />
  </div>
</template>

<script>
import PopupChooseOrder from './popup-choose-order'
export default {
  components: {
    PopupChooseOrder
  },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfData: {
        formData: {
          xie_tong_bill_code: '', // 工程协同号
          check_bill_id: '', // 选择订单
          xie_tong_user_id: '', // 协同工程师id
          xie_tong_user_name: '', // 协同工程师
          qi_wang_date: '', // 期望交期
          create_name_id: '', // 申请人id
          create_name: '', // 申请人
          xie_tong_company_id: '', // 客户id
          xie_tong_company_name: '', // 客户
          xie_tong_saler_company_name: '', // 开单公司
          ding_dan_lei_xing: '销售订单', // 订单类型
          jiao_huo_ri_qi: '', // 交货日期
          fu_jian_file: [], // 附件上传
          qi_ta_yao_qiu: '' // 其他要求
        },

        tableData: []
      },
      formConfig: {
        inline: true,
        width: '240px'
      },
      formColumn: [
        {
          type: 'text',
          title: '工程协同号',
          field: 'xie_tong_bill_code',
          placeholder: '自动生成',
          disabled: true
        },
        {
          type: 'button',
          title: '选择订单',
          placeholder: '选择订单',
          icon: 'vxe-icon-link',
          fnChange: () => {
            this.isShowPopupChooseOrder = true
          }
        },
        {
          type: 'select',
          title: '协同工程师',
          field: 'xie_tong_user_id',
          options: []
        },
        {
          type: 'date',
          title: '期望交期',
          field: 'qi_wang_date',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        },
        {
          type: 'text',
          title: '申请人',
          field: 'create_name',
          placeholder: '自动填充',
          disabled: true
        },
        {
          type: 'text',
          title: '客户',
          field: 'xie_tong_company_name',
          placeholder: '自动填充',
          disabled: true
        },
        {
          type: 'text',
          title: '开单公司',
          field: 'xie_tong_saler_company_name',
          placeholder: '自动填充',
          disabled: true
        },
        {
          type: 'select',
          title: '订单类型',
          field: 'ding_dan_lei_xing',
          width: '240px',
          options: [
            {
              key: '销售订单',
              val: '销售订单'
            },
            {
              key: '来料加工订单',
              val: '来料加工订单'
            }
          ]
        },
        {
          type: 'date',
          title: '交货日期',
          field: 'jiao_huo_ri_qi',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        },
        {
          type: 'upload_file',
          title: '附件上传',
          field: 'fu_jian_file',
          isDelete: true
        },
        {
          type: 'textarea',
          title: '其他要求',
          field: 'qi_ta_yao_qiu',
          width: '100%'
        }
      ],
      tableColumn: [
        {
          fixed: 'left',
          type: 'checkbox',
          width: 40
        },
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          title: '商品图片',
          field: 'list_chan_pin_tu',
          width: 63,
          slots: { default: 'default_list_chan_pin_tu' }
        },
        {
          title: '商品名称',
          field: 'name'
        },
        {
          title: '规格(mm)',
          field: 'spec'
        },
        {
          title: '单位',
          field: 'unit'
        },
        {
          title: '数量',
          field: 'counts'
        },
        {
          title: '单价(元)',
          field: 'sales_price',
          slots: { default: 'default_sales_price' }
        },
        {
          title: '金额(元)',
          field: 'sales_amount',
          slots: { default: 'default_sales_amount' }
        },
        {
          title: '协同备注',
          field: 'xie_tong_bei_zhu',
          slots: { edit: 'edit_xie_tong_bei_zhu' },
          editRender: { autofocus: '.el-input__inner' }
        }
      ],
      isShowPopupChooseOrder: false,
      accountList: []
    }
  },
  computed: {
    // 表格配置合并
    tableConfig() {
      let obj = {
        editConfig: {
          beforeEditMethod() {
            return true
          }
        },
        keyboardConfig: {
          isEdit: true
        }
      }
      let result = this.$util.deepMerge(this.$constant.tableDefaultConfig, obj)
      return result
    },
    selfAccountData() {
      let result = this.$store.getters.getLoginAccount
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.getAccountList()
    this.getAllAccountList()
  },
  methods: {
    // 获取员工列表
    getAccountList() {
      this.$api({
        method: 'post',
        url: '/admin/account/getGongChengShi',
        data: {
          pageSize: this.$constant.pageMax
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = res.data.data.map((item) => {
            return {
              key: item[1],
              val: item[0]
            }
          })
          this.accountList = result.filter((item) => {
            return item.val !== this.selfAccountData.id
          })
          this.formColumn.forEach((item) => {
            if (item.field === 'xie_tong_user_id') {
              item.options = this.$util.deepCopy(this.accountList)
            }
          })
        } else {
          return
        }
      })
    },
    // 获取所有员工列表
    getAllAccountList() {
      this.$api({
        method: 'post',
        url: '/admin/account/getAllYuanGong',
        data: {
          pageSize: this.$constant.pageMax
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = res.data.data.map((item) => {
            return {
              key: item[1],
              val: item[0]
            }
          })
          this.accountList = result.filter((item) => {
            return item.val !== this.selfAccountData.id
          })
        } else {
          return
        }
      })
    },
    // 选择订单成功
    chooseOrderSuccess(val) {
      this.selfData.formData.check_bill_id = val.bill_id
      this.selfData.formData.xie_tong_company_id = val.company_id
      this.selfData.formData.xie_tong_company_name = val.company_name
      this.selfData.formData.xie_tong_saler_company_name = val.saler_company_name
      let list = val.tableSaleData
      this.formColumn.forEach((item) => {
        if (item.title.includes('选择订单')) {
          item.placeholder = `已选订单(${val.bill_code})`
        }
      })
      list.forEach((item) => {
        item.check_bill_goods_id = item.id
        item.is_xie_tong = false
        item.xie_tong_bei_zhu = ''
      })
      this.selfData.tableData = list
    },
    // 获取-当前复选行
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    // 表格底部
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) return '合计'
          if (['counts', 'sales_amount'].includes(column.field)) {
            return this.$util.listFieldTotal(data, column.field)
          }
        })
      ]
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      let rows = this.getCheckboxRecords()
      this.selfData.tableData.forEach((itemSt) => {
        let isCheck = rows.some((itemNd) => {
          return itemNd.id === itemSt.id
        })
        itemSt.is_xie_tong = isCheck
      })
      this.accountList.forEach((item) => {
        if (item.val === this.selfData.formData.xie_tong_user_id) {
          this.selfData.formData.xie_tong_user_name = item.key
        }
      })

      this.$api({
        method: 'post',
        url: '/admin/gcvip/gongChengXieTong/saveOrUpdate',
        data: this.selfData
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.popupCancel()
          this.$emit('success')
          this.$message.success('保存成功')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
